// Removes all falsy values from an object.
const filterParameters = (params) =>
  Object.entries(params)
    .filter(([, value]) => !!value)
    .reduce((acc, [key, value]) => ({ ...acc, [key]: value }), {});

export { filterParameters };
